import React from "react";

const CacheLoading = () => {
    return (
        <div />
    );
}

export default CacheLoading;